export var ACR_REGISTRATION_FORM = {
  form: [{
    id: "partner_id",
    label: "NRDR partner ID",
    maxLength: 5
  }, {
    id: "app_id",
    label: "LCSR app ID",
    maxLength: 10
  }, {
    id: "client_id",
    label: "OAuth client_id",
    maxLength: 100
  }, {
    id: "client_secret",
    label: "OAuth client_secret",
    maxLength: 255
  }, {
    id: "redirect_uri",
    label: "OAuth callback URL registered with ACR",
    maxLength: 500
  }]
};

// ACR View States
export var ACR_VIEWS = {
  FORM: "form",
  LOGIN: "login",
  CONFIG: "config",
  ERROR: "error"
};
// Error Messages
export var ERROR_MESSAGES = {
  WORKSPACE_REQUIRED: "Please select a workspace",
  FIELDS_REQUIRED: "Please fill all required fields",
  REGISTRATION_FAILED: "Failed to register ACR facility",
  SAVE_FAILED: "Failed to save changes",
  LOGIN_STATE_RESTORE_FAILED: "Failed to restore ACR login state"
};

// Success Messages
export var SUCCESS_MESSAGES = {
  REGISTRATION_SUCCESS: "ACR Registration successful",
  CHANGES_SAVED: "Changes saved successfully",
  LOGIN_STATE_RESTORED: "Restored ACR login state from localStorage"
};
export var SUBMISSION_STATUS = {
  PENDING: "pending",
  READY: "ready",
  SUBMITTING: "submitting",
  SUBMITTED: "submitted",
  ACCEPTED: "accepted",
  PARTIALLY_SUCCESSFUL: "partially_successful",
  VALIDATION_FAILED: "validation_failed",
  ERROR: "error",
  REJECTED: "rejected",
  FAILED: "failed"
};
export var ACR_STATUS = {
  ENQUEUED: "Enqueued",
  LOADING: "Loading",
  RECEIVED: "Received",
  POSTED: "Posted",
  ACCEPTED: "Accepted",
  VALIDATION_SUCCESSFUL: "ValidationSuccessful",
  PARTIALLY_SUCCESSFUL: "PartiallySuccessful",
  VALIDATION_FAIL: "ValidationFail",
  FAILED: "Failed",
  UPDATED_WITH_NEW_TRANSACTION: "UpdatedWithNewTransaction"
};
export var FIELD_STATUS = {
  MISSING: "missing",
  COMPLETED: "completed",
  OPTIONAL: "optional"
};
export var FIELD_VISIBILITY = {
  REQUIRED: "required",
  HIDDEN: "hidden",
  OPTIONAL: "optional"
};
// React Query Keys
export var ACR_QUERY_KEYS = {
  PATIENT_REPORTS: "acrPatientReports",
  SUBMISSIONS: "acrSubmissions",
  SUBMISSION_DETAIL: "acrSubmissionDetail",
  FIELD_CONFIGS: "acrFieldConfigs",
  WORKSPACE_CONFIG: "acrWorkspaceConfig"
};